import { useState, useRef, useContext } from "react";
import { useParams } from "react-router-dom";
import { AccountsContext } from "../../../../components/context/account-context";
import { uploadMedia } from "../../../../services/upload-service";

export const useVehicleViewMedia = () => {
    const { accountId } = useContext(AccountsContext);
    const { vehicleId } = useParams();

    const [mediaLoading, setMediaLoading] = useState(false);
    const [media, setMedia] = useState([]);
    const [mediaError, setMediaError] = useState(null);
    const [newlyAddedItem, setNewlyAddedItem] = useState(null);
    const fileInputRef = useRef(null);

    const handleFileSelect = async (event) => {
        const file = event.target.files[0];
        if (!file || mediaLoading) return;

        setMediaLoading(true);
        setMediaError(null);

        try {
            const uploadResponse = await uploadMedia(accountId, file, "vehicle", vehicleId, "");

            if (uploadResponse.success) {
                const newMediaItem = uploadResponse.data.data;

                // Just prepend the new item to the media list
                setMedia((prev) => [newMediaItem, ...prev]);
                setNewlyAddedItem(newMediaItem);
            } else {
                setMediaError(uploadResponse.data.message || "Failed to upload media");
            }
        } catch (error) {
            setMediaError("An error occurred while uploading the media");
        } finally {
            setMediaLoading(false);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        }
    };

    const handleAddMediaClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleRemoveImage = (id) => {
        setMedia((prev) => prev.filter((item) => (item.mediaId || item.localId) !== id));
        if (newlyAddedItem && (newlyAddedItem.mediaId || newlyAddedItem.localId) === id) {
            setNewlyAddedItem(null);
        }
    };

    return {
        mediaLoading,
        media,
        setMedia,
        mediaError,
        setMediaError,
        newlyAddedItem,
        setNewlyAddedItem,
        fileInputRef,
        handleFileSelect,
        handleAddMediaClick,
        handleRemoveImage
    };
}; 